import type { AxiosError } from "axios";
import axios from "axios";

import { config } from "~/data";

export const refreshToken = async () => {
  const logout = () => {
    const url = new URL(`${config.account.scmpAccountHost}/logout`);
    url.searchParams.set("destination", encodeURIComponent(location.href));
    location.href = url.toString();
  };

  try {
    const url = `${config.account.scmpAccountHost}/refreshToken`;
    return await axios.post(url, null, { withCredentials: true });
  } catch (error) {
    const { response } = error as Required<AxiosError<{ code: number; message: string }>>;
    if (response.status === 401 || response.status === 403) {
      logout();
    }
  }
};
